<div *ngIf="meal" class="wrap border-md">
  <div
    class="img"
    [appBackgroundImage]="meal.photos[0] | productImage | async"
    [class.no-image]="meal.photos.length < 1"
  ></div>
  <div class="content">
    <div class="top">
      <div class="title">{{ meal.name }}</div>
      <div class="description">
        {{ meal.description }}
      </div>
    </div>
    <div class="bottom">
      <app-price-label
        [value]="meal | getRelevantProductPrice | appCurrency | async"
        [isCompact]="false"
      ></app-price-label>
      <app-action-button
        *ngIf="!hideBuyButton"
        [label]="'@components.productCard.buyActionBtn' | translate"
      ></app-action-button>
      <app-action-button
        *ngIf="hideBuyButton"
        [label]="'@components.productCard.viewActionBtn' | translate"
      ></app-action-button>
    </div>
  </div>
</div>
